<template>
  <div class="chatter-blank-page">
    <div class="blank-content">
      <h1>No Chatter Found</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatterBlankView",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped>
.chatter-blank-page {
  width: 100%;
  text-align: center !important;
}
.blank-content {
  font-size: 12px !important;
  min-height: 500px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
